/* istanbul ignore file */
import React from 'react';

const withProvider = <P extends Record<string, unknown>>(
    Provider: React.JSXElementConstructor<{children: React.ReactNode}>,
    Component: React.JSXElementConstructor<P>
): React.JSXElementConstructor<P> => {
    const WithProvider = (props: P) => {
        return (
            <Provider>
                <Component {...props} />
            </Provider>
        );
    };
    return WithProvider;
};

export default withProvider;
